$(function() {

    //General form AJAX submits
    $('body').on('submit', '.ajax-form', function(e) {
        e.preventDefault();

        //Get form data
        var $form = $(this);
        var data = $(this).serializeArray();
        var url = $(this).attr('action');

        //Grey out all submit buttons while we're saving...
        $('button[type="submit"]').attr('disabled', 'disabled').html('Sending...');

        grecaptcha.ready(function() {
            grecaptcha.execute(recaptcha_site_key, {action: 'submit'}).then(function(token) {

                //Add recaptcha token to data
                data.push({
                    name: 'recaptcha',
                    value: token
                });

                //Make ajax call to save data
                ajax_call('post', url, data, function(response) {

                    //Reenable all submit buttons after save complete
                    $('button[type="submit"]').html('Sign Up').removeAttr('disabled');

                    //If successful...
                    if(response.response) {

                        //Reset form
                        $form.trigger("reset");

                        //Check for redirect
                        if(response.redirect) {
                            window.location = response.redirect;

                        } else {

                            //Show success form alert message
                            show_alert(true, response.message);
                        }

                        //Otherwise there's an error
                    } else {

                        //Show form alert with error message/s
                        show_alert(false, response.message);

                    }

                });
            });

        });

    });

});